import { useLoginUser } from '@/src/views/states/LoginUser'
import { Props } from './Layout'

export type Params = {
  onClickEditIcon?: () => void
}

export const useProps = ({ onClickEditIcon }: Params): Props => {
  const loginUser = useLoginUser().loginUser

  return {
    userIconUrl: loginUser?.userIconUrl || '',
    userFrameUrl: loginUser?.userFrameUrl || '',
    onClickEditIcon,
  }
}
